import { render, staticRenderFns } from "./ScaleQuestion.vue?vue&type=template&id=4614df54&scoped=true&"
import script from "./ScaleQuestion.vue?vue&type=script&lang=js&"
export * from "./ScaleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614df54",
  null
  
)

export default component.exports